import React from 'react';
import { Box, Typography, Button, Container } from '@mui/material';
import { Block as BlockIcon } from '@mui/icons-material';

const AccessDenied: React.FC = () => {
  return (
    <Container maxWidth="md" sx={{ height: '100vh', display: 'flex', alignItems: 'center' }}>
      <Box sx={{ textAlign: 'center', width: '100%' }}>
        <BlockIcon sx={{ fontSize: 80, color: 'error.main', mb: 2 }} />
        <Typography variant="h3" component="h1" gutterBottom color="error.main">
          Access Denied
        </Typography>
        <Typography variant="body1" paragraph color="text.primary">
          Your access to this application has been restricted.
        </Typography>
        <Button variant="contained" onClick={() => (window.location.href = window.location.origin)} color="primary">
          Return to Login
        </Button>
      </Box>
    </Container>
  );
};

export default AccessDenied;
